/**
 * Normalize API/DB products_supplied: legacy string ids or
 * { product_id, quantity, rate_per_day, weight }.
 */
export function parseProductsSupplied(raw) {
  if (!Array.isArray(raw) || raw.length === 0) return [];
  const out = [];
  for (const x of raw) {
    if (typeof x === "string") {
      const id = x.trim();
      if (id) out.push({ product_id: id, quantity: null, rate_per_day: null, weight: null });
    } else if (x && typeof x === "object" && x.product_id) {
      const id = String(x.product_id).trim();
      if (!id) continue;
      const q = x.quantity;
      let num = null;
      if (q !== null && q !== undefined && q !== "") {
        const n = Number(q);
        if (Number.isFinite(n) && n >= 1) num = n;
      }
      const r = x.rate_per_day;
      let rate = null;
      if (r !== null && r !== undefined && r !== "") {
        const n = Number(r);
        if (Number.isFinite(n) && n >= 0) rate = n;
      }
      const w = x.weight;
      let weight = null;
      if (w !== null && w !== undefined && w !== "") {
        const n = Number(w);
        if (Number.isFinite(n) && n >= 0) weight = n;
      }
      out.push({ product_id: id, quantity: num, rate_per_day: rate, weight });
    }
  }
  return out;
}

/** Keep only lines whose product_id exists in the active catalog. */
export function filterProductsSuppliedToCatalog(lines, catalogProducts) {
  if (!Array.isArray(lines) || lines.length === 0) return [];
  const activeIds = new Set(
    (catalogProducts || []).map((p) => p?.id).filter(Boolean)
  );
  if (activeIds.size === 0) return [];
  return lines.filter((l) => activeIds.has(l.product_id));
}
